<app-cards-basic>
  @if(currentLanguage === 'en'){
    <h3 class="pb-2">Subscribe to monthly report</h3>
  } @else {
    <h3 class="pb-2">Monatsbericht abonnieren</h3>
  }

  @if(userProfile){
    @if(userProfile.product_subscriptions.includes(productId())){
      @if(currentLanguage === 'en'){
        <p class="pb-2">You have subscribed to this product and will receive the monthly report by e-mail.</p>
        <button
          mat-flat-button
          color="primary"
          class="bp-button"
          [routerLink]="['/user-profile' | localize]">
          Manage Product Subscriptions
        </button>
      } @else {
        <p class="pb-2">Sie haben dieses Produkt abonniert und werden den monatlichen Bericht per E-Mail erhalten.</p>
        <button
          mat-flat-button
          color="primary"
          class="bp-button"
          [routerLink]="['/user-profile' | localize]">
          Produktabonnements verwalten
        </button>
      }
    } @else {
      @if(currentLanguage === 'en'){
        <p class="pb-2">To receive the monthly report by e-mail, subscribe to this product.</p>
        <button
          mat-flat-button
          color="primary"
          class="bp-button"
          [routerLink]="['/user-profile' | localize]">
          Receive monthly report by e-mail
        </button>
      } @else {
        <p class="pb-2">Um den Monatsbericht per E-Mail zu erhalten, abonnieren Sie dieses Produkt.</p>
        <button
          mat-flat-button
          color="primary"
          class="bp-button"
          [routerLink]="['/user-profile' | localize]">
          Monatsbericht per E-Mail erhalten
        </button>
      }

    }

  } @else {
    @if(currentLanguage === 'en'){
      <p class="pb-2">To receive a monthly report for this product by e-mail, please log in or register.</p>
      <button
        mat-flat-button
        color="primary"
        class="bp-button"
        [routerLink]="['/register' | localize]">
        Receive monthly report by e-mail
      </button>
    } @else {
      <p class="pb-2">Um einen monatlichen Bericht für dieses Produkt per E-Mail zu erhalten, melden Sie sich bitte an oder registrieren Sie sich.</p>
      <button
        mat-flat-button
        color="primary"
        class="bp-button"
        [routerLink]="['/register' | localize]">
        Monatsbericht per E-Mail erhalten
      </button>
    }

  }


</app-cards-basic>
